@import "../../scss";

.root {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--color-cream);
  display: flex;

  @include media-breakpoint-down("md") {
    flex-direction: column;
  }
}

.viewer {
  flex-grow: 1;
  position: relative;
  font-size: 0;
  @include media-breakpoint-down("md") {
    width: 100%;
  }
}

.loading {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -1rem;
  margin-left: -1rem;
  display: block;
  font-size: 1rem;
  color: var(--color-bright-green);
  @include typo--small-label();
}

.close {
  position: absolute;
  top: var(--spacer-4);
  right: var(--spacer-4);

  @include media-breakpoint-down("md") {
    top: var(--spacer-2);
    right: var(--spacer-2);
  }
}

.items {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  padding: var(--spacer-5) var(--spacer-7);
  flex-basis: 31%;
  max-width: 500px;
  position: relative;
  background: var(--color-swamp-green);

  @include media-breakpoint-down("md") {
    padding: var(--spacer-2);
    padding-right: 0;
    flex-basis: 25%;
    white-space: nowrap;
    flex-direction: row;
    flex-wrap: nowrap;
    max-width: unset;
  }
}

// fixes bug with final border collapsing iOS
.items::after {
  @include media-breakpoint-down("md") {
    width: var(--spacer-2);
    display: block;
    height: auto;
    content: "";
    border: 1px solid transparent;
  }
}

.icon {
  width: 3.5rem;
  height: auto;
  flex-shrink: 0;
  margin-bottom: var(--spacer-5);

  @include media-breakpoint-down("md") {
    display: none;
  }
}
